export function isMiniLot(item) {
  return String(item?.lotVariant || '').toUpperCase() === 'MINI';
}

export function watchlistStockId(script) {
  const id = String(script?.instrumentIdentifier ?? script?.stockId ?? '');
  return isMiniLot(script) ? `${id}#MINI` : id;
}

export function displayScriptName(name) {
  return String(name || '').replace(/ MINI$/i, '');
}
